import { __async } from './chunk-T36PI2YV.mjs';
import * as yup from 'yup';

var onlineOrderingSettingsSchema = () => __async(void 0, null, function* () {
  return yield yup.object().shape({
    acceptingOrders: yup.boolean()
  });
});

export { onlineOrderingSettingsSchema };
